import TYPE_REQUEST from "./TYPE_REQUEST";
// import useToast from "../useToast";



const funtionsValidateResponse = {
    [TYPE_REQUEST.GET_TABLE]: (response, label, newToast) => {
        if (!'response' in response || response.response.constructor.name !== 'Object') {
        };

        if (!response.response.data.length) {
            newToast('No se encontraron datos', 'info');
        };
    },
    [TYPE_REQUEST.GET_LIST]: (response, label, newToast) => {
        if (!'response' in response || Array.isArray(response.response)) {
        };

        if (!response.response.length) {
            newToast('No se encontraron datos', "info");
        };

        console.log({ response, label, type: 'GET_LIST' });
    },
    [TYPE_REQUEST.DELETE]: (response, label) => {
        console.log({ response, label, type: 'DELETE' });
    },
    [TYPE_REQUEST.UPDATE]: (response, label) => {
        console.log({ response, label, type: 'UPDATE' });
    },
    [TYPE_REQUEST.CREATE]: (response, label) => {
        console.log({ response, label, type: 'CREATE' });
    },
}

const validateResponse = (response, label, typeRequest, options, newToast) => {
    let success = false;
    let newResponse = response;

    if (typeRequest in funtionsValidateResponse) {
        const handleErrorCustom = funtionsValidateResponse[typeRequest];
        const responseHandleErrorCustom = handleErrorCustom(response, label, newToast);
        success = responseHandleErrorCustom.success;
        newResponse = responseHandleErrorCustom.newError;
    } 
    return newResponse;
};


export default validateResponse;